import { render, staticRenderFns } from "./AccordionGroupClasseEProduto.vue?vue&type=template&id=fe4dd698&scoped=true&"
import script from "./AccordionGroupClasseEProduto.vue?vue&type=script&lang=js&"
export * from "./AccordionGroupClasseEProduto.vue?vue&type=script&lang=js&"
import style0 from "./AccordionGroupClasseEProduto.vue?vue&type=style&index=0&id=fe4dd698&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4dd698",
  null
  
)

export default component.exports